/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {
    FC,
    $WhenResourcesLoaded,
    ConstructorCallBack,
} from '@gongxigames/framework/core/fragments/BuilderY';

type ResourcesPackage = 'beforePriority' | 'defaultPriority' | 'afterPriority' | 'buyFeature';

export type OnResourcesLoadedProps = {
    children: ConstructorCallBack;
    resources: ResourcesPackage;
};

const MAP_RESOURCES_PACKAGES: Record<ResourcesPackage, string[]> = {
    beforePriority: ['before_priority'],
    defaultPriority: ['default_priority'],
    afterPriority: ['after_priority'],
    buyFeature: ['default_priority', 'default_priority_buy_feature'],
};

/**
 * Executes a callback function when the specified
 * graphics resource packs have been loaded.
 * The result of the callback can be any "JSX.Element"
 * which will be added as a child to the parent elements.
 * In other words, it will create and add components to the scene
 * when the resources are loaded.
 */
export const $OnResourcesLoaded: FC<OnResourcesLoadedProps> = (props) => {
    return <$WhenResourcesLoaded graphics={MAP_RESOURCES_PACKAGES[props.resources]}>
        {props.children}
    </$WhenResourcesLoaded>;
};
